<!--
 * @Author: 杨琼 qiong.yang@xgo.one
 * @Date: 2022-11-23 17:06:40
 * @LastEditors: 杨琼 qiong.yang@xgo.one
 * @LastEditTime: 2024-08-14 16:20:51
 * @FilePath: \choice_bank_web\src\App.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>
<style>
*{
  padding: 0;
  margin: 0
}
</style>
